import React, { ChangeEvent } from "react";
import * as app from "../services/AppService";
import { RowItem } from "../models/Core/row-item";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";
interface SwitchesProps extends RowItem, Omit<InterfaceComponentsProps, "Icon" | "isTable" |"LabelClass"> {
    onChange?: (res: boolean) => void;
    name?: string
    checked?: boolean
}
function Switches(props: SwitchesProps) {
    function handler(event: ChangeEvent<HTMLInputElement>) {
        const { checked } = event.target;
        if (props.onChange && typeof props.onChange == "function")
            props.onChange(checked);
    }
    return (
        <div className={`form-check form-switch mx-2 mt-1 ${props.class}`}>
            <input
                id={props.id ? props.id : "swch" + props.label}
                type="checkbox"
                checked={props.checked}
                name={props.name}
                disabled={props.disabled}
                className="form-check-input"
                onChange={handler}
            />
            <label
                htmlFor={props.name}
                className={"ms-2 form-check-label text-body "}
            >
                {app.translate(props.label)}
            </label>
        </div>
    );
}
Switches.defaultProps = {
    class: "",
    name: "",
    label: "",
    disabled: false,
};
export default Switches;
